var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-page-wrap"},[_c('p',{staticClass:"head"},[_vm._v("Oops!")]),_c('p',{staticClass:"tip"},[_vm._v("You are lost")]),_c('van-image',{attrs:{"width":"100%","src":require('../assets/images/noPage.jpg')}}),_c('router-link',{staticClass:"go-home",attrs:{"to":"/"}},[_vm._v("Back to Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }